// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AdminLogin from './AdminLogin';
import BasicLayout from './components/BasicLayout'; // Importiere BasicLayout
import Dashboard from './pages/admin/Dashboard';  // Admin Dashboard
import EditorDashboard from './pages/editor/Dashboard';  // Editor Dashboard
import PrivateRoute from './PrivateRoute';
import HomepageRequests from './pages/admin/components/HomepageRequests'; // Importiere die Seite
import CustomerReviews from './pages/angebote/CustomerReviews';



const App = () => {
  return (
    <Router>
      <Routes>
        {/* Login Route */}
        <Route path="/" element={<AdminLogin />} />

        {/* Admin Dashboard Route */}
        <Route
          path="/dashboard/*"
          element={
            <PrivateRoute role="admin">
              <Dashboard />
            </PrivateRoute>
          }
        >
          {/* Sub-Routen im Admin Dashboard */}
          <Route path="homepage-requests" element={<HomepageRequests />} />
          {/* Hier können weitere Routen hinzugefügt werden */}
        </Route>

        {/* Editor Dashboard Route */}
        <Route
          path="/editor"
          element={
            <PrivateRoute role="editor">
              <EditorDashboard />
            </PrivateRoute>
          }
        />
        
        {/* Routen ohne Header und Footer */}
        <Route element={<BasicLayout />}>
          <Route path="/angebote/:linkToken" element={<CustomerReviews />} /> {/* Seite ohne Header und Footer */}
        </Route>
        
        
      </Routes>
    </Router>
  );
};

export default App;
